import { IconButton } from '@mui/material';
import { IMenuItem, IMenuList } from '../../interfaces';
import classes from './MobileFooterMenu.module.scss';
import { clsx } from 'clsx';

export const MobileFooterMenu = ({ activePath, list, navigate }: IMenuList) => {
  return (
    <div className={classes.mobileFooterContainer}>
      {list.map(({ id, icon, url, label }: IMenuItem) => {
        const isActive = activePath === url;
        return (
          <IconButton
            className={clsx(classes.button, isActive && classes.activeButton)}
            key={id}
            onClick={() => navigate(url)}
          >
            {icon}
            <span>{label}</span>
          </IconButton>
        );
      })}
    </div>
  );
};
